module.exports = __webpack_public_path__ + "static/media/merriweather-italic-webfont.ad5dd583.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather-italic-webfont.ttf
// module id = 293
// module chunks = 0